import { render, staticRenderFns } from "./AtualizarGrupoRamal.vue?vue&type=template&id=397d07d1&"
import script from "./AtualizarGrupoRamal.vue?vue&type=script&lang=js&"
export * from "./AtualizarGrupoRamal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports